import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const AdminProjectRoute = ({ children }) => {
  const { isLoading, user } = useContext(AuthContext);

  if (isLoading) return null;

  if (user?.user_type !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminProjectRoute;
